interface ItemListProps {
  id: number;
  title: string;
  items: { title: string; id: number }[];
  onItemClick: (id: number) => void;
}

const ItemList = ({ title, items, onItemClick }: ItemListProps) => (
  <div className="item-list">
    <h3>{title}</h3>
    <ul>
      {items.map((item, idx) => {
        return (
          <li key={`${idx},${item.id}`} onClick={() => onItemClick(item.id)}>
            {item.title}
          </li>
        );
      })}
    </ul>
  </div>
);

export { ItemList };
